import { render, staticRenderFns } from "./UploadPoster.vue?vue&type=template&id=e64fdc86&scoped=true&"
import script from "./UploadPoster.vue?vue&type=script&lang=js&"
export * from "./UploadPoster.vue?vue&type=script&lang=js&"
import style0 from "./UploadPoster.vue?vue&type=style&index=0&id=e64fdc86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64fdc86",
  null
  
)

export default component.exports